import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import classNames from "classnames";
import {
  selectIsBundleInCart,
  selectCartBundleQuantity,
  selectIsBundleCanAddMore,
} from "../../redux/cart";
import { useCart } from "../../hooks/useCart";
import { bundleSkusMapper } from "../../helpers/dataMapper";
import { APP_PATHS } from "../../constants/paths";
import ImagePlaceholder from "../UI/ImagePlaceholder/ImagePlaceholder";
import LoadingOverlay from "../UI/Loading/LoadingOverlay/LoadingOverlay";
import AddedToCart from "../UI/AddedToCart/AddedToCart";
import PrimaryButton from "../UI/PrimaryButton/PrimaryButton";
import QuantityControls from "../QuantityControls/QuantityControls";
import Price from "../Price/Price";
import leftArrowIcon from "../../assets/icons/left_arrow.svg";
import classes from "./BundleCard.module.css";

const BundleCard = (props) => {
  const { id, images, name, price, bundleSkus } = props;
  const isAddedToCart = useSelector((state) => selectIsBundleInCart(state, id));
  const cartBundleQuantity = useSelector((state) =>
    selectCartBundleQuantity(state, id)
  );
  const canAddMore = useSelector((state) =>
    selectIsBundleCanAddMore(state, id)
  );
  const {
    bundleQuantityIncreasedHandler,
    bundleQuantityDecreasedHandler,
    isLoading,
  } = useCart();

  const addToCart = async () => {
    await bundleQuantityIncreasedHandler(
      id,
      0,
      1,
      bundleSkusMapper(bundleSkus)
    );
  };

  const increaseQuantity = async () => {
    await bundleQuantityIncreasedHandler(
      id,
      cartBundleQuantity,
      1,
      bundleSkusMapper(bundleSkus)
    );
  };

  const decreaseQuantity = async () => {
    await bundleQuantityDecreasedHandler(
      id,
      cartBundleQuantity,
      1,
      bundleSkusMapper(bundleSkus)
    );
  };

  return (
    <div className={classes["bundle-card"]}>
      <div className={classes["bundle-card__details-container"]}>
        <div className={classes["bundle-card__image-container"]}>
          <ul
            className={classNames(classes["bundle-card__image-list"], {
              [classes["bundle-card__image-list--only-one"]]:
                images.length === 1,
            })}
          >
            {images.slice(0, 4).map((image, index) => (
              <li
                key={index}
                className={classNames(classes["bundle-card__image-list-item"], {
                  [classes["bundle-card__image-list-item--more"]]:
                    images.length > 4,
                })}
              >
                <ImagePlaceholder
                  src={image}
                  alt={bundleSkus[index].commercialName}
                  className={classes["bundle-card__image"]}
                  loading="lazy"
                />
              </li>
            ))}
          </ul>
          {images.length > 4 && (
            <Link
              to={APP_PATHS.BUNDLE_DETAILS.url.replace(":bundleId", id)}
              className={classes["bundle-card__more-link"]}
            >
              <p className={classes["bundle-card__more-details"]}>
                <span
                  className={classNames(
                    classes["bundle-card__more-quantity"],
                    "numeric-content"
                  )}
                >
                  {images.length - 4} +
                </span>
                <span className={classes["bundle-card__more-text"]}>
                  منتجات اخرى
                </span>
              </p>
              <img
                src={leftArrowIcon}
                alt="more"
                className={classes["bundle-card__more-img"]}
              />
            </Link>
          )}
        </div>
        <div className={classes["bundle-card__details"]}>
          <p className={classes["bundle-card__title"]}>مجموعة عرض</p>
          <Link
            to={APP_PATHS.BUNDLE_DETAILS.url.replace(":bundleId", id)}
            className={classes["bundle-card__name"]}
          >
            {name}
          </Link>
        </div>
      </div>
      <div className={classes["bundle-card__footer"]}>
        <Price
          value={price}
          suffix="جنيه"
          className={classes["bundle-card__price-wrapper"]}
          valueClassName={classes["bundle-card__price"]}
          suffixClassName={classes["bundle-card__price-currency"]}
        />
        {!isAddedToCart ? (
          <PrimaryButton
            className={classes["bundle-card__add-to-cart-btn"]}
            onClick={addToCart}
          >
            أضف الى العربة
          </PrimaryButton>
        ) : (
          <div className={classes["bundle-card__quantity-wrapper"]}>
            <QuantityControls
              className={classes["bundle-card__quantity-controls"]}
              quantity={cartBundleQuantity}
              isPlusDisabled={!canAddMore}
              onPlus={increaseQuantity}
              onMinus={decreaseQuantity}
            />
            <AddedToCart isSkuAdded={false} />
          </div>
        )}
      </div>

      {isLoading && <LoadingOverlay />}
    </div>
  );
};

export default BundleCard;

BundleCard.propTypes = {
  id: PropTypes.number,
  images: PropTypes.arrayOf(PropTypes.string),
  name: PropTypes.string,
  price: PropTypes.number,
  bundleSkus: PropTypes.array,
};
